import SiteLayout from '@/components/feature/SiteLayout';
import Hero from '@/pages/home/components/Hero';
import TopicStrip from '@/pages/home/components/TopicStrip';
import LatestFeed from '@/pages/home/components/LatestFeed';
import Spotlight from '@/pages/home/components/Spotlight';
import Subscribe from '@/pages/home/components/Subscribe';
import useSeo from '@/hooks/useSeo';
import { siteMeta } from '@/mocks/site';

const SITE_URL = 'https://kanguabaoliao.cn';

const Home = () => {
  useSeo({
    title: '看瓜爆料 - 独家一手私料 · 内部首发阵地',
    description:
      '看瓜爆料专注娱乐行业独家一手私料与内部首发信息，涵盖顶流追踪、影视内幕、综艺现场、音乐动态、时尚品牌与幕后资本六大栏目，每日更新热榜与深度爆料。',
    keywords: '看瓜爆料,看瓜爆料独家,看瓜爆料一手,看瓜爆料内部,看瓜爆料首发,娱乐爆料,娱乐圈内幕',
    path: '/',
    schema: [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: siteMeta.name,
        url: SITE_URL,
        description: siteMeta.intro,
        email: siteMeta.email,
        foundingDate: siteMeta.since,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: siteMeta.name,
        url: SITE_URL,
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${SITE_URL}/topics?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
    ],
  });

  return (
    <SiteLayout>
      <Hero />
      <TopicStrip />
      <LatestFeed />
      <Spotlight />
      <Subscribe />
    </SiteLayout>
  );
};

export default Home;